import React from 'react';
import { useSelector } from 'react-redux';

import { Grid, Typography, Chip } from '@iclinic/design-system';
import { ErrorAlert } from 'shared/components';
import {
  normalizeTransactionStatus,
  getChipColor,
} from 'features/onlinePayment/utils';
import { getAttemptTransactionDetailSelector } from 'features/onlinePayment/state/reports/transactions/selectors';
import Loader from './Loader';
import { TransactionStatus } from 'features/onlinePayment/state/constants';

const AttemptTransactionSideBar = (): JSX.Element => {
  const {
    fetching,
    attemptTransactionDetail,
    attemptTransactionDetailFetchError,
  } = useSelector(getAttemptTransactionDetailSelector);

  const { status, amount, createdAt, feePercent, installments } =
    attemptTransactionDetail || {};

  return (
    <>
      {fetching && <Loader />}
      {!fetching && attemptTransactionDetail && (
        <Grid container alignItems="flex-start" spacing={4}>
          <Grid item xs={12}>
            <Typography variant="body2" gutterBottom>
              Status da transação
            </Typography>
            <Chip
              label={normalizeTransactionStatus(status as TransactionStatus)}
              severity={getChipColor(status as TransactionStatus)}
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Valor</Typography>
            <Typography color="textPrimary" variant="body1">
              {amount}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Data</Typography>
            <Typography color="textPrimary" variant="body1">
              {createdAt}
            </Typography>
          </Grid>
          {feePercent && (
            <Grid item xs={12}>
              <Typography variant="body2">Taxa</Typography>
              <Typography color="textPrimary" variant="body1">
                {feePercent}%
              </Typography>
            </Grid>
          )}
          {feePercent && installments && (
            <Grid item xs={12}>
              <Typography variant="body2">Parcelamento</Typography>
              <Typography color="textPrimary" variant="body1">
                {installments}x
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
      {attemptTransactionDetailFetchError && (
        <ErrorAlert
          message={
            <span
              dangerouslySetInnerHTML={{
                __html: attemptTransactionDetailFetchError,
              }}
            />
          }
        />
      )}
    </>
  );
};

export default AttemptTransactionSideBar;
